(function () {
	const searchModal = () => {
		$(".search-modal-trigger,.search-modal__overlay,.search__close").click(
			function (e) {
				e.preventDefault();
				searchToggle()
			}
		);
	};
	$(document).on('keyup', function(e) {
		if ($(".search-modal").hasClass('active') && e.key == "Escape") {
			searchToggle()
		}
	});
	function searchToggle(){
		$("#search-modal").toggleClass("active");
		if ($("#search-modal").hasClass('active')) {
			setTimeout(()=> {
				$("#search-modal").find('.search__input').focus();
			},100)
		} else {
			$(".search-modal-trigger").focus();
		}
		$('body').toggleClass("overflow-hidden")
	}

	$('.search-modal [data-collection-card-url]').each(function () {
		const url = $(this).data('collection-card-url');
		const $text = $(this).find('.collection-card__text');

		if (!url || !$text.length) return;

		$text.off('click').on('click', () => {
			if (/^(https?:\/\/|\/)/.test(url)) window.location.href = url;
		});
	})

	document.addEventListener("shopify:section:load", searchModal);
	searchModal();
})();